export default __webpack_public_path__ + "static/media/time.5745e094.png";